<div class="language-selector">
  <ul class="languages">
    <li [class.active]="activeLocale == 'en'"><a [href]="'/en' + currentRoute">EN</a></li>
    <li [class.active]="activeLocale == 'fr'"><a [href]="'/fr' + currentRoute">FR</a></li>
  </ul>
</div>
